import { ConfigProvider, Table, theme } from 'antd'
import Title from 'antd/es/typography/Title'
import { FC } from 'react'
import { PRINTER_SUMMARY_LABELS } from '../constants/printer-summary-labels'
import { PrinterPrintJobRow } from '../hooks/use-printer-print-jobs'
import { columns } from './columns'

interface PrintJobsTableProps {
    rows: PrinterPrintJobRow[]
    isLoading: boolean
}

const PrintJobsTable: FC<PrintJobsTableProps> = ({ rows, isLoading }) => {
    return (
        <ConfigProvider theme={{ algorithm: theme.compactAlgorithm }}>
            <Table
                title={() => (
                    <Title style={{ marginTop: 0 }} level={5}>
                        {PRINTER_SUMMARY_LABELS.printJobs}
                    </Title>
                )}
                columns={columns}
                dataSource={rows}
                rowKey='key'
                size='small'
                pagination={false}
                loading={isLoading}
            />
        </ConfigProvider>
    )
}

export default PrintJobsTable
